import React from 'react'
import styled from 'styled-components'
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded'
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded'
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded'
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded'
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'

const PROPS = [
  { Icon: FactCheckRoundedIcon, label: 'Every obligation mapped' },
  { Icon: DescriptionRoundedIcon, label: 'Documents auto-matched' },
  { Icon: NotificationsActiveRoundedIcon, label: 'Expiry alerts' },
  { Icon: SpeedRoundedIcon, label: 'One live score' },
]

const ComplianceInactiveNotice = () => (
  <Hero>
    <Inner>
      <Badge><AutoAwesomeRoundedIcon style={{ fontSize: 15 }} /> New feature</Badge>
      <Headline>See exactly where every building stands on compliance</Headline>
      <Sub>
        Compliance tracking isn't switched on for your account yet. Once it is, Building Passport maps every
        statutory and contractual obligation for each of your buildings, automatically matches the documents you
        already hold as the evidence, keeps an eye on every expiry date, and rolls it all into one always-current
        compliance score. No more chasing spreadsheets, no nasty surprises.
      </Sub>

      <Props>
        {PROPS.map(({ Icon, label }) => (
          <Prop key={label}>
            <PropIcon><Icon style={{ fontSize: 18 }} /></PropIcon>
            <span>{label}</span>
          </Prop>
        ))}
      </Props>

      <CtaRow>
        <Cta href='mailto:rupert@buildingpassport.com?subject=Switch%20on%20compliance%20tracking'>
          Talk to us about switching it on
          <ArrowForwardRoundedIcon style={{ fontSize: 18 }} />
        </Cta>
        <Or>or email <a href='mailto:rupert@buildingpassport.com'>rupert@buildingpassport.com</a></Or>
      </CtaRow>
    </Inner>
  </Hero>
)

export default ComplianceInactiveNotice

const Hero = styled.div`
  position: relative;
  overflow: hidden;
  background: #0c1229;
  border-radius: 16px;
  padding: 28px 30px;
  margin: 6px 0 24px;
  box-shadow: 0 8px 24px rgba(12, 18, 41, 0.18);
`

const Inner = styled.div`
  position: relative;
  max-width: 760px;
`

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(210, 71, 36, 0.18);
  color: #ffb59a;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 5px 11px;
  border-radius: 999px;
  margin-bottom: 14px;
`

const Headline = styled.h2`
  margin: 0 0 10px;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.2px;
`

const Sub = styled.p`
  margin: 0 0 18px;
  font-size: 14.5px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
`

const Props = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 22px;
  margin-bottom: 22px;
`

const Prop = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
`

const PropIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffb59a;
`

const CtaRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 16px;
`

const Cta = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #d24724;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  padding: 11px 20px;
  border-radius: 10px;

  &:hover {
    filter: brightness(1.06);
  }
`

const Or = styled.span`
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.6);

  a {
    color: rgba(255, 255, 255, 0.85);
    font-weight: 700;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`
